import { JobTaskTableFields, SubTypeField } from '@/enums';
import { FilterMatchMode } from 'primereact/api';
import { ColumnFilter } from '@/features/jobs-tasks/types';
import { DEFAULT_TIME_WINDOW, RELATIVE_MATCH_MODE } from './relative-time.constants';

export const ALL_COLUMN_FILTERS: ColumnFilter[] = [
    {
        name: JobTaskTableFields.SUB_TYPE,
        value: [SubTypeField.JOB_ROOT],
        matchMode: FilterMatchMode.IN,
    },
    {
        name: JobTaskTableFields.STATUS,
        value: [],
        matchMode: FilterMatchMode.IN,
    },
    {
        name: JobTaskTableFields.WORKFLOW_ID,
        value: [],
        matchMode: FilterMatchMode.IN,
    },
    {
        name: JobTaskTableFields.TASK_DESCRIPTION,
        value: '',
        matchMode: FilterMatchMode.CONTAINS,
    },
    {
        name: JobTaskTableFields.ELAPSED,
        value: '',
        matchMode: FilterMatchMode.GREATER_THAN,
    },
    {
        name: JobTaskTableFields.START_TIME,
        value: DEFAULT_TIME_WINDOW,
        matchMode: RELATIVE_MATCH_MODE,
    },
    {
        name: JobTaskTableFields.END_TIME,
        value: [''],
        matchMode: FilterMatchMode.GREATER_THAN,
    },
    {
        name: JobTaskTableFields.PROJECT,
        value: [],
        matchMode: FilterMatchMode.IN,
    },
    {
        name: JobTaskTableFields.JOB_ID,
        value: '',
        matchMode: FilterMatchMode.CONTAINS,
    },
    {
        name: JobTaskTableFields.TASK_SUMMARY,
        value: '',
        matchMode: FilterMatchMode.CONTAINS,
    },
    {
        name: JobTaskTableFields.TASK_NAME,
        value: '',
        matchMode: FilterMatchMode.CONTAINS,
    },
    {
        name: JobTaskTableFields.PARENT_ID,
        value: '',
        matchMode: FilterMatchMode.EQUALS,
    },
];
